import type { AzureApi } from '@ipen-portal/plugin-azure-storage-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const azureStorageApiRef = createApiRef<
  TRPCOptionsProxy<AzureApi>
>().with({
  id: 'plugin.ipen.azure-storage.api',
});
